"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolTip = exports.listToolTipVariants = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const router_1 = require("next/router");
const styled_components_1 = __importDefault(require("styled-components"));
const styles_1 = require("../styles");
const framer_motion_1 = require("framer-motion");
const transition = Object.assign({}, (0, styles_1.getTransition)(.5));
exports.listToolTipVariants = {
    inactive: {
        opacity: 0,
        transition
    },
    enter: {
        opacity: 1,
        transition: Object.assign(Object.assign({}, (0, styles_1.getTransition)(.5)), { staggerChildren: .01 })
    },
    exit: {
        opacity: 0,
        transition
    }
};
const TRANSLATIONS = {
    'es-ES': {
        'title': 'PRODUCTO SUPERFRESCO',
        'description': 'Hay existencias limitadas de este producto para garantizar que es súper fresco. Recomendamos ordenar con 3 días de anticipación para asegurar disponibilidad. A pedidos urgentes con menos tiempo: haremos todo lo posible para atenderlo en la fecha solicitada o lo antes posible'
    },
    'en-EU': {
        'title': 'SUPERFRESH PRODUCT',
        'description': ' There\'s limited stock of this product to warranty it\'s super fresh. We recommend ordering with 3 days in advance to ensure availability. To urgent orders with less time: we\'ll do our best to seve it at the requested date or as soon as possible'
    },
    'es-MD': {
        'title': 'PRODUCTO SUPERFRESCO',
        'description': 'Hay existencias limitadas de este producto para garantizar que es súper fresco. Recomendamos ordenar con 3 días de anticipación para asegurar disponibilidad. A pedidos urgentes con menos tiempo: haremos todo lo posible para atenderlo en la fecha solicitada o lo antes posible'
    },
    'es-CN': {
        'title': 'PRODUCTO SUPERFRESCO',
        'description': 'Hay existencias limitadas de este producto para garantizar que es súper fresco. Recomendamos ordenar con 3 días de anticipación para asegurar disponibilidad. A pedidos urgentes con menos tiempo: haremos todo lo posible para atenderlo en la fecha solicitada o lo antes posible'
    },
    'es-CT': {
        'title': 'PRODUCTE SUPERFRESC',
        'description': 'Hi ha estoc limitat d\'aquest producte per garantir que és molt fresc. Recomanem fer la comanda amb 3 dies d\'antelació per garantir la disponibilitat. Per a comandes urgents amb menys temps: farem tot el possible per atendre-les en la data sol·licitada o el més aviat possible'
    },
    'de-DE': {
        'title': 'SUPERFRISCHES PRODUKT',
        'description': 'Dieses Produkt ist nur begrenzt vorrätig, um sicherzustellen, dass es superfrisch ist. Wir empfehlen, 3 Tage im Voraus zu bestellen, um die Verfügbarkeit zu gewährleisten. Für dringende Bestellungen mit weniger Zeit: Wir werden unser Bestes tun, um sie zum gewünschten Datum oder so schnell wie möglich zu liefern'
    },
    'fr-FR': {
        'title': 'PRODUIT SUPER FRAIS',
        'description': ' There\'s limited stock of this product to warranty it\'s super fresh. We recommend ordering with 3 days in advance to ensure availability. To urgent orders with less time: we\'ll do our best to seve it at the requested date or as soon as possible'
    },
    'en-GB': {
        'title': 'SUPERFRESH PRODUCT',
        'description': 'Il y a un stock limité de ce produit pour garantir qu\'il est super frais. Nous vous recommandons de commander avec 3 jours à l\'avance pour garantir la disponibilité. Pour les commandes urgentes avec moins de temps: nous ferons de notre mieux pour le régler à la date demandée ou dès que possible'
    },
    'pt-PT': {
        'title': 'PRODUTO SUPER FRESCO',
        'description': 'Há estoques limitados deste produto para garantir que ele seja super fresco. Recomendamos fazer o pedido com 3 dias de antecedência para assegurar a disponibilidade. Para pedidos urgentes com menos tempo: faremos o possível para atendê-lo na data solicitada ou o mais breve possível'
    }
};
exports.ToolTip = (0, react_1.memo)(({ showTooltip }) => {
    const { locale } = (0, router_1.useRouter)();
    return ((0, jsx_runtime_1.jsx)(framer_motion_1.AnimatePresence, Object.assign({ mode: 'wait' }, { children: showTooltip && ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)(Wrapper, Object.assign({ className: 'tooltip', "$active": showTooltip, variants: exports.listToolTipVariants, initial: 'inactive', animate: 'enter', exit: 'exit' }, { children: [(0, jsx_runtime_1.jsx)("p", Object.assign({ className: 'title' }, { children: TRANSLATIONS[locale].title })), (0, jsx_runtime_1.jsxs)("p", Object.assign({ className: 'description' }, { children: [TRANSLATIONS[locale].description, " "] }))] })) })) })));
});
const Wrapper = styled_components_1.default.div `
  background-color: ${({ theme }) => theme.colors.darkred};
  height: ${(0, styles_1.vw)(170, 'mobile')};
  left: ${(0, styles_1.vw)(-75, 'mobile')};
  padding: ${(0, styles_1.vw)(21, 'mobile')} ${(0, styles_1.vw)(10, 'mobile')};
  position: relative;
  top: ${(0, styles_1.vw)(10, 'mobile')};
  width: ${(0, styles_1.vw)(170, 'mobile')};

  ${styles_1.mq.greaterThan('nexus7')} {
    height: ${(0, styles_1.vw)(170, 'nexus7')};
    left: ${(0, styles_1.vw)(-75, 'nexus7')};
    padding: ${(0, styles_1.vw)(21, 'nexus7')} ${(0, styles_1.vw)(10, 'nexus7')};
    top: ${(0, styles_1.vw)(10, 'nexus7')};
    width: ${(0, styles_1.vw)(170, 'nexus7')};
  }

  ${styles_1.mq.greaterThan('tablet')} {
    padding: ${(0, styles_1.vw)(21, 'desktop')} ${(0, styles_1.vw)(10, 'desktop')};
    width: ${(0, styles_1.vw)(270, 'desktop')};
    height: ${(0, styles_1.vw)(150, 'desktop')};
    left: ${(0, styles_1.vw)(-120, 'desktop')};
    top: ${(0, styles_1.vw)(10, 'desktop')};
  }

  ${styles_1.mq.greaterThan('desktop')} {
    padding: 21px 10px;
    width: 270px;
    height: 150px;
    left: -120px;
    top: 10px;
  }

   &:after{
    content: "";
    display: block;
    border: ${(0, styles_1.vw)(10, 'mobile')} solid transparent;
    border-bottom-color: ${({ theme }) => theme.colors.darkred};
    position: absolute;
    top: ${(0, styles_1.vw)(-20, 'mobile')};
    left: 46%;

    ${styles_1.mq.greaterThan('tablet')} {
      top: ${(0, styles_1.vw)(-20, 'desktop')};
      left: 45%;
      border: ${(0, styles_1.vw)(10, 'desktop')} solid transparent;
      border-bottom-color: ${({ theme }) => theme.colors.darkred};
    }

    ${styles_1.mq.greaterThan('desktop')} {
      top: 20px;
      border: 10px solid transparent;
    }
  }

  p {
    ${(0, styles_1.getP12_1)()}
    background-color: none;
    color: ${({ theme }) => theme.colors.white};
    text-align: center;
  }

  .title {
    padding-bottom: ${(0, styles_1.vw)(10, 'mobile')};

    ${styles_1.mq.greaterThan('nexus7')} {
      padding-bottom: ${(0, styles_1.vw)(10, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      padding-bottom: ${(0, styles_1.vw)(10, 'desktop')};
    }

    ${styles_1.mq.greaterThan('desktop')} {
      padding-bottom: 10px;
    }
  }
`;
